import {Button, Flex, Image, Modal, Space, Tag, Typography} from "antd";
import React from "react";
import {Cover} from "../../components/Cover";
import '@mdxeditor/editor/style.css';
import {Component} from "../../feature/project/setting";
import Markdown from "react-markdown";
import {useParams} from "react-router-dom";

export interface ViewComponentProps {
    component: Component,
    visible: boolean,
    onCancel: () => void,
}

export const ViewComponentModal = (props: ViewComponentProps) => {
    const hasTags = props.component.tags && props.component.tags.length > 0;
    const hasAssets = props.component.assets && props.component.assets.length > 0;
    const hasReferences = props.component.references && props.component.references.length > 0;
    const {projectId, storyId} = useParams();

    return (
        <Modal
            maskClosable={false}
            open={props.visible}
            destroyOnClose={true}
            title={`View component / ${props.component.category?.title}`}
            okText={'Close'}
            onOk={props.onCancel}
            onCancel={props.onCancel}
            width={1000}
            footer={<Button type={'primary'} onClick={props.onCancel}>Close</Button>}
        >
            <Flex gap={16}>
                <Cover
                    projectId={projectId}
                    storyId={storyId}
                    editable={false} style={{position: "relative", height: 400, width: 350, flex: 'none'}}
                       cover={props.component.cover}/>
                <Space direction={'vertical'} style={{width: '100%', maxHeight: 400, overflowY: 'auto', scrollbarWidth: "none"}} size={16}>
                    <Typography style={{fontWeight: 700, fontSize: 18}}>{props.component.title}</Typography>
                    <Markdown className={"markdown-text"}>{props.component.description}</Markdown>
                    {hasAssets ?
                        <div>
                            <Typography style={{fontWeight: 700}}>Assets</Typography>
                            <Image.PreviewGroup>
                                <Flex gap={8} wrap={'wrap'}>{props.component.assets?.map(asset =>
                                    <Image key={asset.id} className={'small-cover'}
                                           src={asset.content ? asset?.content : '/images/placeholder.png'}
                                           style={{
                                               width: 100,
                                               height: 100,
                                               borderRadius: 6,
                                               objectFit: 'cover'
                                           }}/>)}</Flex>
                            </Image.PreviewGroup>
                        </div>
                        : ''}
                    {hasTags ?
                        <div>
                            <Typography style={{fontWeight: 700}}>Tags</Typography>
                            <Flex>{props.component.tags?.map(tag => <Tag key={tag.id}>{tag.title}</Tag>)}</Flex>
                        </div> : ''}
                    {hasReferences ?
                        <div>
                            <Typography style={{fontWeight: 700}}>References</Typography>
                            <Image.PreviewGroup>
                                <Flex gap={8} wrap={'wrap'}>{props.component.references?.map(reference =>
                                    <Image key={reference.id} className={'small-cover'}
                                           src={reference.content ? reference?.content : '/images/placeholder.png'}
                                           style={{
                                               width: 100,
                                               height: 100,
                                               borderRadius: 6,
                                               objectFit: 'cover'
                                           }}/>)}</Flex>
                            </Image.PreviewGroup>
                        </div> : ''}
                </Space>
            </Flex>
        </Modal>
    );
}